import { apiClient } from "@/lib/api-client";
import type { IdentityQuery } from "@/lib/identity-contract";

import type { ProfileRevision, ProfileRevisionsResponse } from "./types";

/**
 * The service caps this at 200. Asking for more would be a 400, so the console
 * asks for a page it knows it can get and reports the total alongside it.
 */
export const REVISION_PAGE_SIZE = 50;

export interface ProfileRevisionsResult {
  revisions: readonly ProfileRevision[];
  total: number;
}

export async function listProfileRevisions(
  userId: string,
  limit: number = REVISION_PAGE_SIZE
): Promise<ProfileRevisionsResult> {
  const query: NonNullable<IdentityQuery<"listProfileRevisions">> = { limit };
  const path = `/identity/users/${encodeURIComponent(userId)}/profile-revisions?limit=${String(query.limit)}`;
  const response = await apiClient.get<ProfileRevisionsResponse>(path);
  return { revisions: response.data, total: response.meta.total };
}
